"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const MinorityOwned = createSVGIcon(
  <>
    <circle cx="13.0332" cy="9.5" r="6.5" fill="#E8E1D2" />
    <path
      d="M21.0664 18C17.8903 18 17.8903 15.4 14.7092 15.4C11.5331 15.4 11.5331 18 8.35696 18C5.17585 18 5.17585 15.4 1.99974 15.4"
      stroke="#312921"
      strokeMiterlimit="10"
    />
    <path
      d="M21.0664 13.8C17.8903 13.8 17.8903 11.2 14.7092 11.2C11.5331 11.2 11.5331 13.8 8.35696 13.8C5.17585 13.8001 5.17585 11.2001 1.99974 11.2001"
      stroke="#312921"
      strokeMiterlimit="10"
    />
  </>,
  "Minority owned",
  {
    viewBox: "0 0 24 24",
    fill: "none",
  }
);
